import { render, staticRenderFns } from "./TagSpecialtyList.vue?vue&type=template&id=76ef3812&scoped=true&"
import script from "./TagSpecialtyList.vue?vue&type=script&lang=ts&"
export * from "./TagSpecialtyList.vue?vue&type=script&lang=ts&"
import style0 from "./TagSpecialtyList.vue?vue&type=style&index=0&id=76ef3812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ef3812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
